import React from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ChangeTemporaryPasswordForm from '../components/form/ChangeTemporaryPasswordForm'
import { changeTemporaryPassword } from '../store/passwordRecovery/actions'

const ChangeTemporaryPasswordPage = ({ lang }) => {
  const { token } = useParams()
  const { t } = useTranslation()

  return (
    <div>
      <ChangeTemporaryPasswordForm
        lang={lang}
        translation={t}
        token={token}
      />
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  lang: auth.lang
})

const mapDispatchToPros = dispatch => bindActionCreators({ changeTemporaryPassword }, dispatch)

export default connect(mapStateToProps, mapDispatchToPros)(ChangeTemporaryPasswordPage)
